<main class="page">
  <a class="back-link" routerLink="/">Back to village</a>

  <section class="panel">
    <p class="eyebrow">{{ location }}</p>
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
  </section>
</main>
